export const ContainerPresented = 'ContainerPresented';
export const ContainerClosed = 'ContainerClosed';
export const SurveyCompleted = 'SurveyCompleted';